module.exports = __webpack_public_path__ + "static/media/asesoriajuridica_maf.74d635a4.jpg";